// src/utils/dateUtils.ts

export type DateFormatType =
  | "date"
  | "dateTime"
  | "dateTimeWithSeconds";

/**
 * Accepts null as well as undefined: every DTO in the project declares optional timestamps as
 * `string | null`, and the body already treats both as "no date" via the `!dateString` guard.
 * The wider type keeps callers from having to sprinkle `?? undefined` at each call site.
 */
export const formatDateTime = (
  dateString?: string | null,
  format: DateFormatType = "dateTime"
): string => {
  if (!dateString) return "-";

  const date = new Date(dateString);

  const baseOptions: Intl.DateTimeFormatOptions = {
    month: "long",
    day: "numeric",
    year: "numeric",
  };

  switch (format) {
    case "date":
      return date.toLocaleDateString("en-US", baseOptions);

    case "dateTime":
      return date.toLocaleString("en-US", {
        ...baseOptions,
        hour: "numeric",
        minute: "2-digit",
        hour12: true,
      });

    case "dateTimeWithSeconds":
      return date.toLocaleString("en-US", {
        ...baseOptions,
        hour: "numeric",
        minute: "2-digit",
        second: "2-digit",
        hour12: true,
      });

    default:
      return date.toLocaleString("en-US");
  }
};



